import { render } from "./bcrs_popup.vue?vue&type=template&id=4897d165&scoped=true"
import script from "./bcrs_popup.vue?vue&type=script&lang=js"
export * from "./bcrs_popup.vue?vue&type=script&lang=js"

import "./bcrs_popup.vue?vue&type=style&index=0&id=4897d165&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4897d165"]])

export default __exports__